<template>
  <div id="lexinDictionary">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-7">
        <div class="breadcrumbs">
          <p :lang=selectedLanguageCode>{{ $t('message.you-are-here') }}</p>
          <ul>
            <li>
              <router-link tag="a" to="/">{{ $t('message.LEXIN') }}</router-link>
            </li>
            <li>
              <font-awesome-icon icon="arrow-right" class="right-agap"/>
              <span>{{ $t('message.main-page') }}</span>
            </li>
          </ul>
        </div>
      </div>
      <Language></Language>
    </div>
    <div class="row">
      <div class="col-12">
        <h1>
          <span>{{ $t('message.main-page') }}</span>
        </h1>
        <div class="clearfix"></div>
        <div class="home-info">
          <p>{{ $t('message.short-description-2') }}</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-6 col-md-6 col-lg-6">
        <nav class="home-mid-link" :aria-label="$t('message.bokmal-dictionaries')">
          <h2>{{ $t('message.bokmal-dictionaries') }}</h2>
          <ul>
            <li>
              <a
                href="Javascript:void(0)"
                @click="search('message.bokmal-monolingual')"
              >
                  <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.bokmal-monolingual') }}
              </a>
            </li>
            <li>
              <a
                href="Javascript:void(0)"
                @click="search('message.bokmal-nynorsk')">
                  <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.bokmal-nynorsk') }}
              </a>
            </li>
            <li>
              <a
                href="Javascript:void(0)"
                @click="search('message.bokmal-english')">
                <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.bokmal-english') }}
                </a>
            </li>
            <li>
              <a
                href="Javascript:void(0)"
                @click="search('message.bokmal-arabic')">
                <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.bokmal-arabic') }}
              </a>
            </li>
            <li>
              <a
                href="Javascript:void(0)"
                @click="search('message.bokmal-burmese')">
                  <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.bokmal-burmese') }}
              </a>
            </li>
            <li>
              <a
                href="Javascript:void(0)"
                @click="search('message.bokmal-dari')">
                  <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.bokmal-dari') }}
              </a>
            </li>
            <li>
              <a
                href="Javascript:void(0)"
                @click="search('message.bokmal-filipino')">
                <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.bokmal-filipino') }}
              </a>
            </li>
            <li>
              <a
                href="Javascript:void(0)"
                @click="search('message.bokmal-kurmanji')">
                <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.bokmal-kurmanji') }}
              </a>
            </li>
            <li>
              <a
                href="Javascript:void(0)"
                @click="search('message.bokmal-sorani')">
                <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.bokmal-sorani') }}
              </a>
            </li>
            <li>
              <a
                href="Javascript:void(0)"
                @click="search('message.bokmal-lithuanian')">
                <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.bokmal-lithuanian') }}
              </a>
            </li>
            <li>
              <a
                href="Javascript:void(0)"
                @click="search('message.bokmal-persian')">
                <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.bokmal-persian') }}
              </a>
            </li>
            <li>
              <a
                href="Javascript:void(0)"
                @click="search('message.bokmal-polish')">
                <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.bokmal-polish') }}
              </a>
            </li>
            <li>
              <a
                href="Javascript:void(0)"
                @click="search('message.bokmal-russian')">
                <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.bokmal-russian') }}
              </a>
            </li>
            <li>
              <a
                href="Javascript:void(0)"
                @click="search('message.bokmal-somali')">
                <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.bokmal-somali') }}
              </a>
            </li>
            <li>
              <a
                href="Javascript:void(0)"
                @click="search('message.bokmal-tamil')">
                <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.bokmal-tamil') }}
              </a>
            </li>
            <li>
              <a
                href="Javascript:void(0)"
                @click="search('message.bokmal-thai')">
                <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.bokmal-thai') }}
              </a>
            </li>
            <li>
              <a
                href="Javascript:void(0)"
                @click="search('message.bokmal-tigrinya')">
                <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.bokmal-tigrinya') }}
              </a>
            </li>
            <li>
              <a
                href="Javascript:void(0)"
                @click="search('message.bokmal-turkish')">
                <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.bokmal-turkish') }}
              </a>
            </li>
<!--            <li>-->
<!--              <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/>-->
<!--              <a-->
<!--                href="Javascript:void(0)"-->
<!--                @click="search('message.bokmal-ukrainian')"-->
<!--                v-html="$t('message.bokmal-ukrainian')"-->
<!--              />-->
<!--            </li>-->
            <li>
              <a
                href="Javascript:void(0)"
                @click="search('message.bokmal-urdu')">
                <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.bokmal-urdu') }}
              </a>
            </li>
            <li>
              <a
                href="Javascript:void(0)"
                @click="search('message.bokmal-vietnamese')">
                <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.bokmal-vietnamese') }}
              </a>
            </li>
          </ul>
        </nav>
      </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <nav class="home-mid-link" :aria-label="$t('message.nynorsk-dictionaries')">
                <h2>{{ $t('message.nynorsk-dictionaries') }}</h2>
                <ul>
                    <li>
                        <a
                            href="Javascript:void(0)"
                            @click="search('message.nynorsk-monolingual')">
                            <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.nynorsk-monolingual') }}
                        </a>
                    </li>
                    <li>
                        <a
                            href="Javascript:void(0)"
                            @click="search('message.nynorsk-bokmal')">
                            <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.nynorsk-bokmal') }}
                        </a>
                    </li>
                    <li>
                        <a
                            href="Javascript:void(0)"
                            @click="search('message.nynorsk-english')">
                            <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.nynorsk-english') }}
                        </a>
                    </li>
                    <li>
                        <a
                            href="Javascript:void(0)"
                            @click="search('message.nynorsk-arabic')">
                            <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.nynorsk-arabic') }}
                        </a>
                    </li>
                    <li>
                        <a
                            href="Javascript:void(0)"
                            @click="search('message.nynorsk-burmese')">
                            <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.nynorsk-burmese') }}
                        </a>
                    </li>
                    <li>
                        <a
                            href="Javascript:void(0)"
                            @click="search('message.nynorsk-dari')">
                            <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.nynorsk-dari') }}
                        </a>
                    </li>
                    <li>
                        <a
                            href="Javascript:void(0)"
                            @click="search('message.nynorsk-filipino')">
                            <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.nynorsk-filipino') }}
                        </a>
                    </li>
                    <li>
                        <a
                            href="Javascript:void(0)"
                            @click="search('message.nynorsk-kurmanji')">
                            <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.nynorsk-kurmanji') }}
                        </a>
                    </li>
                    <li>
                        <a
                            href="Javascript:void(0)"
                            @click="search('message.nynorsk-sorani')">
                            <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.nynorsk-sorani') }}
                        </a>
                    </li>
                    <li>
                        <a
                            href="Javascript:void(0)"
                            @click="search('message.nynorsk-lithuanian')">
                            <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.nynorsk-lithuanian') }}
                        </a>
                    </li>
                    <li>
                        <a
                            href="Javascript:void(0)"
                            @click="search('message.nynorsk-persian')">
                            <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.nynorsk-persian') }}
                        </a>
                    </li>
                    <li>
                        <a
                            href="Javascript:void(0)"
                            @click="search('message.nynorsk-polish')">
                            <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.nynorsk-polish') }}
                        </a>
                    </li>
                    <li>
                        <a
                            href="Javascript:void(0)"
                            @click="search('message.nynorsk-russian')">
                            <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.nynorsk-russian') }}
                        </a>
                    </li>
                    <li>
                        <a
                            href="Javascript:void(0)"
                            @click="search('message.nynorsk-somali')">
                            <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.nynorsk-somali') }}
                        </a>
                    </li>
                    <li>
                        <a
                            href="Javascript:void(0)"
                            @click="search('message.nynorsk-tamil')">
                            <img @load="onImgLoad" alt="" width="20px" height="20px" src="../assets/images/left-arrow.svg"/> {{ $t('message.nynorsk-tamil') }}
                        </a>
                    </li>
                    <li>
                        <a
                            href="Javascript:void(0)"
                            @click="search('message.nynorsk-thai')">
                            <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.nynorsk-thai') }}
                        </a>
                    </li>
                    <li>
                        <a
                            href="Javascript:void(0)"
                            @click="search('message.nynorsk-tigrinya')">
                            <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.nynorsk-tigrinya') }}
                        </a>
                    </li>
                    <li>
                        <a
                            href="Javascript:void(0)"
                            @click="search('message.nynorsk-turkish')">
                            <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.nynorsk-turkish') }}
                        </a>
                    </li>
                    <!--            <li>-->
                    <!--              -->
                    <!--              <a-->
                    <!--                href="Javascript:void(0)"-->
                    <!--                @click="search('message.nynorsk-ukrainian')"-->
                    <!-- <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.nynorsk-ukrainian') }} -->
                    <!-- </a> -->
                    <!--            </li> -->
                    <li>
                        <a
                            href="Javascript:void(0)"
                            @click="search('message.nynorsk-urdu')">
                            <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.nynorsk-urdu') }}
                        </a>
                    </li>
                    <li>
                        <a
                            href="Javascript:void(0)"
                            @click="search('message.nynorsk-vietnamese')">
                            <img @load="onImgLoad" alt="" width="20" height="20" src="../assets/images/left-arrow.svg"/> {{ $t('message.nynorsk-vietnamese') }}
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
  </div>
</template>

<script>
import Language from "./Language.vue";

export default {
  name: "LexinDictionaryComponent",
  data() {
    return {
       languageCodeList:[
        {lang:'eng',langISOCode:'en'},
        {lang:'nny',langISOCode:'nn'},
        {lang:'nbo',langISOCode:'nb'}
      ]
    }
  },
  computed: {
    selectedLanguageCode () {
      return this.languageCodeList.find(x=>x.lang==localStorage.getItem('lang')).langISOCode;
    },
  },
  components: {
    Language
  },
  methods: {
    search(val) {
      localStorage.removeItem("searchWord");
      this.$router.push({
        name: "FindwordsComponent",
        params: { dictionary: val, isSearch: true }
      });
    },
    onImgLoad(event) {
      const imgEl = event.target;
      imgEl.alt = this.getLinkLanguageText(imgEl);
    },
    getLinkLanguageText(event) {
        let value = '';

        const link = event.closest('a');
        if (link) {
            value = this.$t("message.navigate_to") + ' ' + Array.from(link.childNodes)
                .filter(node => node.nodeType === Node.TEXT_NODE)
                .map(node => node.textContent.trim())
                .join(' ');

        }

        return value;
    }
  },
  created() {
    $("body,html").animate(
      {
        scrollTop: 0
      },
      60
    );
  }
};
</script>

